export default (http) => {
    const _http = http;

    return {
        creditLoad(params) {
            return _http.post('/cash/credit/creditLoad', params)
        },
        checkAuth(params) {
            return _http.post('/cash/credit/checkAuth', params)
        },
        creditRepayLoad(params) {
            return _http.post('/cash/credit/creditRepayLoad', params)
        },
        creditRepayApply(params) {
            return _http.post('/cash/credit/creditRepayApply', params)
        },
        creditRepaySure(params) {
            return _http.post('/cash/credit/creditRepaySure', params)
        },
        creditRepayQuery(params) {
            return _http.post('/cash/credit/creditRepayQuery', params)
        },
        creditRepayRecordQuery(params) {
            return _http.post('/cash/credit/creditRepayRecordQuery', params)
        },
        creditBankQuery() {
            return _http.post('/cash/credit/creditBankQuery')
        },
        creditBindLoad(params) {
            return _http.post('/cash/credit/creditBindLoad', params)
        },
        creditBind(params) {
            return _http.post('/cash/credit/creditBind', params)
        },
        queryCreditCardBin(params) {
            return _http.post('/cash/credit/queryCardBin', params)
        },
        creditManageLoad(params) {
            return _http.post('/cash/credit/creditManageLoad', params)
        },

        setCreditCardInfo(params) {
            return _http.post('/cash/credit/setCreditCardInfo', params)
        },
        unSign(params) {
            return _http.post('/cash/credit/unSign', params)
        },
        creditRepayCheck(params) {
            return _http.post('/cash/credit/creditRepayCheck', params)
        },
        addChargeCard(params) {
            return _http.post('/cash/credit/addChargeCard', params)
        }
    }
}